import Method from './method';
import Platform from './platform';
import Campaign from './campaign';
import Summary from './summary';

export const getSteps = (currentStep: number) => {
  switch (currentStep) {
    case 0:
      return <Method />;
    case 1:
      return (
        <Platform
          connected_platforms={[
            { id: 'google', adAccountName: 'Ad Account 1' },
            { id: 'tiktok', adAccountName: 'Ad Account 2 Ad Account 2' },
            { id: 'meta', adAccountName: 'Ad Account 3' },
            { id: 'google', adAccountName: 'Ad Account 4 Ad Account 4' }
          ]}
        />
      );
    case 2:
      return (
        <Campaign
          campaigns={[
            {
              id: '1',
              type: 'video',
              name: 'Video 1',
              time: '03:23'
            },
            {
              id: '1',
              type: 'video',
              name: 'Video 1',
              time: '03:23'
            },
            {
              id: '2',
              type: 'campaign',
              name: 'Campaign 1'
            },
            {
              id: '3',
              type: 'campaign',
              name: 'Campaign 2'
            },
            {
              id: '4',
              type: 'video',
              name: 'Video 2',
              time: '03:23'
            }
          ]}
        />
      );
    case 3:
      return <Summary campaignTotal="3" videoTotal="13" kpiTotal="8" />;
    default:
      return <Method />;
  }
};
